import React from 'react';

export default function OrganizationIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9444 10.5556H1.05556C0.475 10.5556 0 11.0306 0 11.6111V17.9444C0 18.525 0.475 19 1.05556 19H17.9444C18.525 19 19 18.525 19 17.9444V11.6111C19 11.0306 18.525 10.5556 17.9444 10.5556ZM4.22222 16.8889C3.06111 16.8889 2.11111 15.9389 2.11111 14.7778C2.11111 13.6167 3.06111 12.6667 4.22222 12.6667C5.38333 12.6667 6.33333 13.6167 6.33333 14.7778C6.33333 15.9389 5.38333 16.8889 4.22222 16.8889ZM17.9444 0H1.05556C0.475 0 0 0.475 0 1.05556V7.38889C0 7.96944 0.475 8.44444 1.05556 8.44444H17.9444C18.525 8.44444 19 7.96944 19 7.38889V1.05556C19 0.475 18.525 0 17.9444 0ZM4.22222 6.33333C3.06111 6.33333 2.11111 5.38333 2.11111 4.22222C2.11111 3.06111 3.06111 2.11111 4.22222 2.11111C5.38333 2.11111 6.33333 3.06111 6.33333 4.22222C6.33333 5.38333 5.38333 6.33333 4.22222 6.33333Z"
        fill="#FFFFFF"
      />
    </svg>
  );
}
